package io.zsoft.models

import io.zsoft.util.Constants.SHORT_TEXT
import io.zsoft.util.Res

enum class Testimonial(
    val image: String,
    val fullName: String,
    val profession: String,
    val review: String
) {
    First(
        image = Res.Image.avatar1,
        fullName = "Milica Ilic",
        profession = "Web Designer",
        review = SHORT_TEXT
    ),
    Second(
        image = Res.Image.avatar2,
        fullName = "Stefan Jovanovic",
        profession = "Android Developer",
        review = SHORT_TEXT
    ),
    Third(
        image = Res.Image.avatar3,
        fullName = "Ana Milic",
        profession = "Business Analyst",
        review = SHORT_TEXT
    ),
    Fourth(
        image = Res.Image.avatar4,
        fullName = "Darko Pesic",
        profession = "Top Manager",
        review = SHORT_TEXT
    ),
    Fifth(
        image = Res.Image.avatar5,
        fullName = "Milena Nesovic",
        profession = "HR Recruiter",
        review = SHORT_TEXT
    ),
    Sixth(
        image = Res.Image.avatar6,
        fullName = "Aca Rodic",
        profession = "Cyber Security Analyst",
        review = SHORT_TEXT
    )
}